export const convertWaterLv2Storage = (siteId, waterLv) => {
  switch (siteId) {
    case 'maengud_pressure':
      return 18828.5938394749 + (-105.568384160654 * waterLv) + (0.148059906932583 * (waterLv ** 2));
    default:
      console.warn(`Cannot find regession formula for ${siteId}`);
      return waterLv;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/utils/waterStorage.js